import { createAction } from '@reduxjs/toolkit';
import StatisticsLogVO from 'commons/vo/param/StatisticsLogVO';
import {
  REQUEST_STATISTICS_LOG,
  REQUEST_STATISTICS_LOG_SUCCESS,
  REQUEST_STATISTICS_LOG_FAILURE,
} from './types';

export const requestStatisticsLog = createAction<
  { param: StatisticsLogVO },
  typeof REQUEST_STATISTICS_LOG
>(REQUEST_STATISTICS_LOG);
export const requestStatisticsLogSuccess = createAction<{ streamingCount: number }>(
  REQUEST_STATISTICS_LOG_SUCCESS,
);
export const requestStatisticsLogFailure = createAction(REQUEST_STATISTICS_LOG_FAILURE);
